import { IVanillaReaderUI } from "../VanillaReaderUI/IVanillaReaderUI";
import { IVanillaReaderUiComponentController } from "../VanillaReaderUI/IVanillaReaderUiComponentController";
import { VanillaReaderUI } from "../VanillaReaderUI/VanillaReaderUI";
import { VanillaReaderUiDialog } from "../VanillaReaderUI/VanillaReaderUiDialog";

export interface MasterPlanUIStartController extends IVanillaReaderUiComponentController, IVanillaReaderUI {
}


export class MasterPlanUIStartController {

    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        // Static event callbacks that are triggered regardless of what dialog instance are opened and closed.
        VanillaReaderUiDialog.sharedOnDialogOpened(vanillaReaderUiContext._uiEvent_dialogOpened.bind(vanillaReaderUiContext));
        VanillaReaderUiDialog.sharedOnDialogClosed(vanillaReaderUiContext._uiEvent_dialogClosed.bind(vanillaReaderUiContext));
    }

}
